<template>
    <v-container>
        <EdicaoProgressao :etapa="etapa" />
        <EdicaoForm
            :camposList="camposList"
            :dominiosList="dominiosList"
            :getFilteredList="(formData) => getFilteredList(formData)"
            :hasFilteredList="filteredList.length>0"
            :list="filteredList"
            :sendEtapa="(val, formData) => sendEtapa(val, formData)"
            :showClose="() => showClose()"
            :etapaType="etapa"
            :tipoGuiaId="tipoGuiaId"
            :grupoEconomico="grupoEconomico"
        />
        <v-col v-if="etapa==3" class="text-center px-0 py-0" cols="12">
          <h1 class="mb-5">Processamento da edição</h1>
          <p class="mb-8">
            Aguarde até que todas guias ou itens que cumpram as condições sejam
            alterados.
          </p>
          <v-btn
            class="ma-2"
            :loading="loader=='loading'"
            :disabled="loader=='loading'"
            color="primary"
            icon
            size="50px"
          ><v-icon size="50px">mdi-cached</v-icon>
          </v-btn>
        </v-col>

        <v-col v-show="etapa==4" class="text-center px-0 py-0" cols="12">
          <h1 class="mb-2">Processamento da edição</h1>
          <p class="mb-3">A edição em massa foi concluída com sucesso.</p>
          <v-container style="max-width: 400px">
            <v-card outlined color="#CDDED4">
              <v-card-text style="font-size:15px">
               <span v-if="qtd_guias_alteradas>0">Substituições feitas em <b>{{qtd_guias_alteradas}} {{qtd_guias_alteradas>1?'guias':'guia'}} </b>.</span>
               <span v-else>Nenhuma guia foi alterada.</span>
              </v-card-text>
          </v-card>
          </v-container>
          <!-- <v-col class="pt-2 pb-4">
            <a @click="showOpen('desfazer'); valTeste = 5">
                <b>Desfazer e voltar ao estado inicial do lote</b>
            </a>
          </v-col> -->
        </v-col>

        <v-col v-show="etapa==5" class="text-center px-0 py-0" cols="12">
          <h1 class="mb-5">Processamento da edição</h1>
          <v-col class="text-center pt-1 pb-2" cols="12">
            <v-icon size="60px" color="red"> fa-exclamation-circle </v-icon>
           </v-col>
            <v-container style="max-width: 400px">
            <v-card outlined color="#FAE5E8">
              <v-card-text style="font-size:15px">
                A edição em massa <b>não pode ser concluída.</b>
              <small><pre v-html="erros"></pre></small>
              </v-card-text>
          </v-card>
          </v-container>
          <p class="mb-6 mt-3">Entre em contato com o suporte para mais informações.</p>
        </v-col>

        <v-col class="text-center pa-0" v-show="etapa==4 || etapa==5">
            <v-btn
            outlined
            height="30px"
            small
            color="primary"
            depressed
            @click="comeBack()"
            >Voltar para lista de guias</v-btn>
        </v-col>
  </v-container>
</template>

<script>
import EdicaoProgressao from './EdicaoProgressao'
import EdicaoForm from './EdicaoForm'
export default {
  components: {
    EdicaoProgressao,
    EdicaoForm,
  },  
  data() {
    return {
      qtd_guias_alteradas: 0,
      erros: '',
      loading: false,
      loader: null,
      etapa: null,
      valTeste: 4,
      tipoConsulta: null,
      filteredList: []
    };
  },
  props: {
    tipoGuiaId: String,
    camposList: Array,
    dominiosList: Array,
    showClose: Function,
    showOpen: Function,
    updateGuias: Function,
    updateGuiasResult: Object,
    formatDate: Function,
    parseDate: Function,
    grupoEconomico: Number
  },
  watch: {
    updateGuiasResult:{
      deep: true,
      handler(val){
        if(val) {
          this.erros = val.erros.map(el=> el.codigo?'código:'+ el.codigo : '').join('<br>') 
          this.loader = null;
          this.qtd_guias_alteradas = val.qtd_guias_alteradas? val.qtd_guias_alteradas : 0
          this.etapa = val.sucesso? 4 : 5;
        } else {
          this.erros = null
          this.qtd_guias_alteradas = 0
          this.etapa =  3
        }
      }
    }
  },
  methods: {
    sendEtapa(val, formData) {
        this.etapa = val
        if (val == 3) {
            this.loader = 'loading'
            this.updateGuias(formData)
        }
    },
    comeBack() {
        this.etapa = 0
        this.loader = null
        this.showClose()
    }
  }
};
</script>

<style>
</style>

